import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';
import { GenesysCloudPlatformApiService } from './genesys-cloud-platform-api.service';

@Injectable({
  providedIn: 'root'
})

export class GenesysCloudPlatformAppsApiService extends GenesysCloudPlatformApiService {

  constructor(
    protected readonly httpClient: HttpClient,
    protected configService: GenesysCloudConfigService) {

    super(httpClient, configService);
    super.commonHeaders$ = this.configService.apiConfig$.pipe(
      tap(apiConfig => super.apiHost = apiConfig.apiEndpoints.purecloudUri),
      map(apiConfig => ({ Authorization: `Bearer ${apiConfig.accessToken}`}))
    );
  }
}
